class FHCardSlider extends HTMLElement {
  connectedCallback() {
    // Find slider elements inside this custom element
    const slider = this.querySelector('.fh-card-slider[data-slider]');
    if (!slider) return;
    const track = slider.querySelector('[data-slider-track]');
    const slides = slider.querySelectorAll('[data-slide]');
    const prevBtn = slider.querySelector('[data-prev]');
    const nextBtn = slider.querySelector('[data-next]');
    let slideCount = slides.length;
    let current = 0;

    function getSlidesPerView() {
      const style = getComputedStyle(slider);
      return parseInt(style.getPropertyValue('--cards-per-page')) || 4;
    }

    function goTo(page) {
      const perPage = getSlidesPerView();
      const totalPages = Math.ceil(slideCount / perPage);
      if (page < 0) page = totalPages - 1;
      if (page >= totalPages) page = 0;
      current = page;
      const slideWidth = slides[0].offsetWidth;
      track.scrollTo({
        left: slideWidth * perPage * current,
        behavior: 'smooth'
      });
    }

    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goTo(current - 1);
    });
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goTo(current + 1);
    });
    window.addEventListener('resize', () => goTo(current));
  }
}

customElements.define('fh-card-slider-js', FHCardSlider);
